import { inject, Injectable } from '@angular/core';
import { DialogService } from '@beyonnex/bx-angular-ui';
import { TranslateService } from '@ngx-translate/core';
import { catchError, EMPTY, from, Observable, switchMap } from 'rxjs';
import { NotificationsService } from '../../../services/notifications/notifications.service';
import type { GeoLocationModalData } from './geo-location-modal.models';

/** Opens the map modal, loading it on demand: it pulls MapLibre (over a megabyte) in, which no page pays for until a map is opened. */
@Injectable({ providedIn: 'root' })
export class GeoLocationModalService {
  private readonly dialog = inject(DialogService);
  private readonly notifications = inject(NotificationsService);
  private readonly translate = inject(TranslateService);

  /** Emits once the modal has been closed; a map that cannot be loaded is reported and completes the stream empty. */
  open(data: GeoLocationModalData): Observable<void> {
    return from(import('./geo-location-modal.component')).pipe(
      switchMap(
        ({ GeoLocationModalComponent }) =>
          this.dialog.open(GeoLocationModalComponent, { width: GeoLocationModalComponent.WIDTH, data }).afterClosed$,
      ),
      catchError((error: unknown) => {
        console.error('Failed to open the geolocation modal', error);
        this.notifications.addGenericErrorNotification(this.translate.instant('geoLocation.modal.openFailed'));
        return EMPTY;
      }),
    );
  }
}
